
export default {
  name: 'NoData',
  components: {
  },
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    freeText: {
      type: String,
      default: ''
    },
    freeButton: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      textInfo: {}
    }
  },
  watch: {
    type (val) {
      this.setData(val)
    }
  },
  created () {
    this.setData(this.type)
  },
  methods: {
    reContents (text) {
      return text.split('\n')
    },
    setData (type) {
      const infoItems = {
        // 타입 정리 안 되어 있음
        normal: {
          icon: 'icon-notice',
          titleText: ''
        },
        restock: {
          icon: 'icon-notice',
          titleText: '신청 내역이 없습니다.',
        },
        alarm: {
          icon: 'icon-notice',
          titleText: '알림 내역이 없습니다.',
        },
        search1: {
          icon: 'icon-notice',
          titleText: '선택한 조건에 맞는 검색결과가 없습니다.',
        },
        search2: {
          icon: 'icon-notice',
          titleText: '검색결과가 없습니다.',
        },
        search3: {
          icon: 'icon-notice',
          titleText: '검색 결과가 없습니다.\n다른 키워드로 검색해 보세요.',
        },
        search4: {
          icon: 'icon-notice',
          titleText: '선택한 조건에 맞는 컨텐츠가 없습니다\n필터를 다시 선택해주세요.'
        },
        cart: {
          icon: 'icon-notice',
          titleText: '장바구니에 담긴 상품이 없습니다.',
          buttonText: '쇼핑하러 가기',
        },
        cancle: {
          icon: 'icon-notice',
          titleText: '취소 신청 내역이 없습니다.'
        },
        contents: {
          icon: 'icon-notice',
          titleText: '콘텐츠 작성하고\n다이소몰 캐시 최대 500C 받아가세요\n긴 글 작성은 PC에서만 가능합니다',
        },
        coupon: {
          icon: 'icon-notice',
          titleText: '받을 수 있는 쿠폰이 없습니다.',
        },
        giftcard: {
          icon: 'icon-notice',
          titleText: '판매 중인 상품권이 없어요.',
        },
        point: {
          icon: 'icon-notice',
          titleText: '보내거나 받은 포인트 선물 내역이 없습니다.'
        },
        review: {
          icon: 'icon-notice',
          titleText: '리뷰를 기다리고 있어요.',
        },
        faq: {
          icon: 'icon-notice',
          titleText: '문의 내역이 없습니다.'
        },
        customer: {
          icon: 'icon-notice',
          titleText: '아직 문의한 적이 없어요\n이전 문의 내역이 필요하시면 고객센터에 문의바랍니다.',
        },
        quest: {
          icon: 'icon-notice',
          titleText: '심사내역이 없습니다.'
        },
        temporary: {
          icon: 'icon-notice',
          titleText: '임시 저장된 글이 없습니다.'
        },
        order: {
          icon: 'icon-notice',
          titleText: '주문내역이 없습니다.'
        },
        package: {
          icon: 'icon-notice',
          titleText: '꾸러미가 비어있어요.',
          linkText: '쇼핑하러 가기',
          path: '/ds',
        },
        notice: {
          icon: 'icon-notice',
          titleText: '등록된 공지사항이 없습니다.'
        },
        exhibition: {
          icon: 'icon-notice',
          titleText: '운영되는 기획전이 없습니다.\n새로운 기획전으로 찾아뵙겠습니다.',
        },
        event: {
          icon: 'icon-notice',
          titleText: '운영되는 이벤트가 없습니다.\n새로운 이벤트로 찾아뵙겠습니다.',
        },
        eventResult: {
          icon: 'icon-notice',
          titleText: '이벤트에 참여하지 않으셨네요.',
          linkText: '진행 중 이벤트 보러가기',
          path: '/ev/evc/SCR_EVC_0001',
        },
        endEvent: {
          icon: 'icon-notice',
          titleText: '종료된 이벤트 입니다.',
        },
        mission: {
          icon: 'icon-notice',
          titleText: '진행가능한 미션이 없어요.'
        },
        myProduct: {
          icon: 'icon-notice',
          titleText: '찜한 상품이 없습니다.',
        },
        showProduct: {
          icon: 'icon-notice',
          titleText: '최근 본 상품이 없습니다.',
        },
        notifyProduct: {
          icon: 'icon-notice',
          titleText: '알림 신청 가능한 상품이 없습니다.',
          linkText: '신상 보러가기',
          path: '/ds/newShorts/C124/feed',
        },
        address: {
          icon: 'icon-notice',
          titleText: '배송지를 등록하고\n더 편리하게 이용 가능해요.'
        },
        store: {
          icon: 'icon-notice',
          titleText: '픽업매장을 등록하고\n더 편리하게 이용 가능해요.'
        },
        noProd: {
          icon: 'icon-notice',
          titleText: '현재 운영중인 상품이 없습니다.',
        },
        defaultProduct: {
          icon: 'icon-notice',
          titleText: '대체 가능한 상품이 없습니다',
        },
        conditionProduct: {
          icon: 'icon-notice',
          titleText: '선택한 조건에 맞는 상품이 없습니다.',
        },
        noProdcut: {
          icon: 'icon-notice',
          titleText: '일시적인 문제로 상품을 불러오지 못했습니다.',
        },
        noPrice: {
          icon: 'icon-notice',
          titleText: '남은 결제금액이 없습니다.',
        }
      }
      this.textInfo = infoItems[type]
    }
  }
}
